module.exports = {
  language: '中文',
  nav: {
    Home: '首页',
    Attackwarn: '攻击预警',
    Product: '我的产品',
    DomainNames: '全部域名',
    Certmanage: '证书管理',
    HandleLog: '操作日志',
    LoginLog: '登录日志',
    googleCheck: '谷歌验证',
    tip1: '请输入旧密码',
    tip2: '请输入新密码',
    tip3: '新密码和确认密码不一致'
  },
  footer: {
    bqDesc: '转载内容版权归作者及来源网站所有，本站原创内容转载请注明来源，商业媒体及纸媒请先联系',
    smAddr: '法律声明浙ICP备',
    secondDesc: '转载内容版权归作者及来源网站所有，本站原创内容转载请注明来源，商业媒体及纸媒请先联系',
    beiAn: '法律声明浙ICP备09109183号-25浙公网安备 33010002000124号',
  },
  AttackWarn: {
    Attackwarn: '攻击预警',
    domain: '域名',
    attackCount: '攻击次数',
    originIp: '来源IP',
    remark: '备注',
    date: '时间',
    type: '类型',
  },
  product: {
    myProduct: '我的产品',
    ProductName: '产品名称',
    createDate: '创建日期',
    addedDomain: '已添加/可添加域名数',
    setMeal: '套餐',
    handle: '操作',
    flow: '流量',
    statuscode: '状态码',
    hitrate: '命中率',
    defense: '防御',
    productlist: '产品列表',
    Statistics: '统计',
    cache: '缓存',
    strategy: '策略',
    cacheType: '缓存类型',
    cacheTip: '多个文件类型以竖杠“|”分割',
    cacheDate: '缓存时间',
    cacheDateTip: '单位秒，最长2592000（30天）,填0则不缓存',
    forceCache: '强制缓存',
    forceCacheTip: '资源缓存时去除 URL「?」后的全部参数进行缓存',
    commit: '提交',
    allRefresh: '全站刷新',
    shield: '屏蔽',
    Intercept: '拦截动作',
    onlyWarning: '仅预警',
    InterceptOnly: '仅拦截',
    BlackList: 'IP拉入黑名单',
    MatchType: '匹配类型',
    matchTip: '模糊匹配和精准匹配两种模式共存',
    FuzzyMatch: '模糊匹配',
    PreciseMatch: '精准匹配',
    inputTip: '多个以换行分割',
    delete: '删除',
    childDomain: '子域名',
    mark: '掩码'
  },
  allDomain: {
    DomainNames: '全部域名',
    domain: '域名',
    createDate: '创建日期',
    mainDomain: '主域名',
    group: '所属群组',
    products: '所属产品',
    status: '状态',
    cert: '证书',
    originSettings: '源站设置',
    originReplace: '源站替换',
    forceJump: '强制跳转',
    DefenseStrategy: '防御策略',
    cleanCache: '缓存清理',
    sourceDetect: '回源检测',
    cachefollow: '缓存跟随',
    stop: '停用',
    start: '启用',
    delete: '删除',
    addsubdomain: '新增子域名',
    config: '配置',
    redirect: '重定向',
    originBroadband: '回源带宽',
    second: '秒',
    longLink: '长链接',
    linkTip: '该数值必须在10~600之间，默认为600秒',
    add: '新增',
    linkMode: '跳转方式',
    redictLink: '跳转链接',
    rootDomain: '根域名',
    ShieldEmptyUA: '屏蔽空UA',
    IPWhiteList: 'IP白名单',
    whitelistMask: 'IP白名单掩码',
    URLWhiteList: 'URL白名单',
    IPBlackList: 'IP黑名单',
    blackListMark: 'IP黑名单掩码',
    URLBlackList: 'URL黑名单',
    ShieldingArea: '区域屏蔽',
    checkedAll: '全选',
    JsguardDefense: 'jsGuard防御',
    CaptchaDefense: '验证码防御',
    TriggerDefenseFrequency: '触发防御频率',
    commonFrequency: '普通频率',
    BaseStationFrequency: '基站频率',
    passwordAuth: '密码认证',
    confirm: '确定',
    cancel: '取消',
    cleanTip: '确定清理所选域名的缓存?',
    SetDefense: '批量设置防御',
    ShieldingUA: '屏蔽UA',
    JSShield: 'JS盾',
    VerificationCode: '验证码',
    BatchforceJump: '批量强制跳转',
    applyCert: '申请证书',
    applyTip1: '@和*一起申请问题会导致txt错误，请申请完一个后再申请另一个',
    applyTip2: '@和*解析为同一个，请提前将 _acme-challenge.域名 指向别名 域名.obtain-ssl.com',
    originOper: '源站批量操作',
    originSite: '源站',
    originSiteAdd: '源站添加',
    childDomain: '子域名列表',
    originAddress: '回源地址',
    InternetProtocol: '通讯协议',
    addRootDomain: '添加根域名',
    URLRule: 'URL规则',
    visitLog: '访问日志',
    visitDate: '访问时间',
    originAddr: '访问地址',
    status: '状态',
    method: '方法',
    InternetAddr: '网址',
    origin: '来源',
    maintain: '维护',
    statusCode: '状态码',
    maintainPage: '维护页面',
    upstreamTip: '可填写多个子域名和源站（一行一个，最多100个），端口（1~65535），端口后面加小写s表示源站是https',
    submitCerts: '上传证书',
    subdomainTip: '子域名可空',
    subdomainTip2: '目录可空',

    timeGranularity: '时间粒度',
    timeFrame: '时间范围',
    query: '查询',
    minute: '分钟',
    hour: '小时',
    day: '天',
    last7days: '最近7天',
    last30days: '最近30天',
    flowtip1: '请选择时间粒度', // Please select time granularity
    flowtip2: '请选择时间范围',
    reqflow: '入流量(MB)',
    sendflow: '出流量(MB)',
    second: '次',
    DefenseTimes: '防御次数(次)',
    RequestRitRatio: '请求命中率(%)',
    TrafficHitRate: '流量命中率(%)',
    sourceflow: '回源流量(MB)',
    Asia: '亚洲',
    Europe: '欧洲',
    SouthAmeria: '南美洲',
    NorthAmeria: '北美洲',
    Africa: '非洲',
    Oceania: '大洋洲',
    tip11: '是否维护',
    tip22: '不能填写302',
    tip33: '整个html页面，请为页面设置编码格式，否则可能出现乱码！',
    close: '关闭',
    applyMethod: '申请方式',
    certContent: '证书内容',
    tip44: '只支持pem格式',
    tip55: '私钥内容',
    tip66: '申请类型',
    tip77: 'DNS自动签发证书',
    tip88: '请选择产品',
    tip99: '请填写域名',
    tip1: '可填写多个源站IP/域名（一行一个，最多10个），端口（1~65535），端口后面加小写s表示源站是https',
    tip2: '可填写多主域名,英文状态下的","区分',
    tip3: '被替换源',
    tip4: '替换成',
    tip5: '请输入密码',
    tip6:'请输入主域名',
    tip7: '请输入子域名',
    tip8: '请至少选择一条域名！',
    tip9: '无效输入内容',
    tip10: '被替换源不能带端口',
    tip111: 'js防御',
    tip112: '验证码防御',
    tip113: '设置成功',
    tip114: '上传成功',
    tip115: '申请成功',
    tip116: '请输入证书内容',
    tip117: '请输入证书秘钥'

  },
  certManage: {
    certManage: '证书管理',
    cert: '证书',
    certStatus: '证书状态',
    type: '类型',
    autoRenew: '自动续期',
    forceDel: '强制删除',
    certSource: '证书来源',
    dueDate: '到期时间',
    tip: '提示',
    tipDes: 'HTTP证书申请，确定提交选中域名？',
    commit: '提交',
    all: '全部',
    Expire: '过期',
    due: '即将到期',
    normal: '正常',
    applying: '申请中',
    applyingovertime: '申请超时',
    ManualUpload: '手动上传',
    httpApply: 'http申请',
    dnsApply: 'dns申请',
    No: '否',
    Yes: '是',
    delete: '删除',
    tip1: '证书，是否继续?',
  },
  handleLog: {
    logList: '日志列表',
    name: '名称',
    desc: '描述',
    modify: '修改值',
    operDate: '操作时间',
  },
  LoginLog: {
    loginDate: '登录时间',
  },
  Login: {
    username: '用户名',
    placeholdName: '请输入您的用户ID',
    pwd: '密码',
    placeholdPwd: '请输入您的密码',
    googleCheckcode: '谷歌验证码',
    checkDesc: '请输入您的谷歌验证码',
    checkTip: '账号没开启的谷歌验证情况下不需要输入。',
    login: '登录',
    slideText: '拖动滑块验证',
    valided: '验证通过',
  },
  Home: {
    accessDomain: '接入域名(个)',
    attackedDomain: '被攻击域名(个)',
    ProductQuantity: '产品数量(个)',
    MaximumTrafficDomain: '最大流量域名(个)',
    table1: '流量排行Top10域名',
    table1Desc: '时间粒度5分钟，5分钟内累计流量',
    sysMsg: '系统消息',
    newMsg: '您有新消息',
    seletDate: '选择日期',
    createDate: '创建日期',
    bindGoogle: '绑定谷歌验证',
    outnetll: '出网流量：单位M',
    outnetl: '出网流量',
    Cachehitrate: '缓存命中率',
    Requesthitrate: '请求命中率',
    Traffichitrate: '流量命中率',
    Domain: '域名',
    Attacks: '攻击次数',
    Connections: '连接数'
  },
  common: {
    filter: '筛选',
    domain: '域名',
    search: '搜索',
    reset: '重置',
    noContent: '暂无内容',
    refresh: '刷新',
    BatchOper: '批量操作',
    loginout: '退出',
    updatePwd: '修改密码',
    pleaseSelect: '请选择',
    success: '操作成功',
  },
  updatePwd: {
    userName: '邮箱/用户名',
    oldPwd: '旧登录密码',
    newLoginPwd: '新登录密码',
    confirmPwd: '确认密码',
  },
  settings: {
    cache: '缓存',
    cacheType: '缓存类型',
    cacheTypeTip: 'html|js|css|jpg …多个文件类型以竖杠“|”分割',
    cacheTime: '缓存时间',
    cacheTimeout: '缓存超时',
    cacheTimeoutTip: '单位秒',
    cacheLimit: '回源带宽',
    cacheLimitTip: '单位MB',
    cacheLimitTTL: 'TTL',
    cacheLimitTTLTip: '每多少秒',
    closeCache: '关闭缓存',
    closeCacheTip: '强制关闭所有缓存，也包括智能缓存，针对所有的API特殊需求的系统，防止缓存影响系统。',
    useRespMaxAge: '缓存时间跟随源',
    useRespMaxAgeTip: '如果源站设置了对应后缀的缓存时间，则cdn对该后缀缓存时间走源的设置',
    strategy: '策略',
    keepaliveTime: '长连接',
    keepaliveTimeTip: '该数值必须在10-600之间，仅用于HTTP，WEBSOCKET非HTTP协议超时时间已设置默认为600秒',
    ssltype1: '@证书',
    ssltype2: '*证书',
    ssl_type0: '@ 证书',
    ssl_type1: '* 证书（一级）',
    ssl_type2: '*.* 证书（二级）',
    ssl_type3: '*.*.* 证书（三级）',
    ssl_type4: 'www 证书',
    ssl_type5: 'm 证书',
  },
  googleCode: {
   googlecode: '谷歌验证码',
   step1: '第一步',
   step2: '第二步',
   step3: '第三步',
   SecretKeyOperation: '秘钥操作',
   secretKeyContent: '通过产生秘钥按钮产生秘钥',
   bindOper: '绑定操作',
   bindContent: '通过谷歌验证器上的6位数字绑定设备',
   tip: '温馨提示',
   tipContent: '此账号已经绑定令牌,如需其他帮助请联系管理员',
   createKey: '产生秘钥',
   tip6: '谷歌验证器上的6位数字',
   tip7: '创建密钥接口返回的secret值',
   bind: '绑定',
   lastTip: '恭喜,您已成功绑定令牌!',
   tip1: '请输入code',
   tip2:'请先产生秘钥',
  }
};

